import type { FileUploaderProps } from "./FileUploader.types";
import { getFileUploaderStyles } from "./FileUploader.styles";
import { useFileUploader } from "./useFileUploader";
import { Icon } from "../../atoms/Icon";
import { Button } from "@/atoms/Button";

export const FileUploader = ({
  label = "Upload de documento",
  onFileSelect,
  onView,
  acceptedFileTypes,
  initialFile = null,
  disabled = false,
  ...props
}: FileUploaderProps) => {
  // Consome o hook com toda a lógica
  const { file, isDragging, getRootProps, getInputProps, handleReplace, handleView } =
    useFileUploader({
      initialFile,
      onFileSelect,
      onView,
      acceptedFileTypes,
      disabled,
    });

  const styles = getFileUploaderStyles({
    isDragging,
    disabled,
    hasFile: !!file,
  });

  // --- Renderização ---

  const renderSelectedFileState = () => (
    <div className="flex w-full flex-col items-center overflow-hidden justify-center gap-3">
      <span
        className="truncate font-medium text-dark-100"
        title={file!.name}
      >
        {file!.name}
      </span>
      <div className="flex flex-shrink-0 flex-wrap justify-center items-center gap-3">
        {onView && (
          <Button
            variant="outline"
            icon="eye"
            type="button"
            onClick={handleView}
            disabled={disabled}
          >
            Visualizar
          </Button>
        )}
        <Button
          variant="outline"
          icon="file-upload"
          type="button"
          onClick={handleReplace}
          disabled={disabled}
        >
          Substituir
        </Button>
      </div>
    </div>
  );

  const renderDropzoneState = () => (
    <>
      <Icon name="file-upload" />
      <span>{label}</span>
    </>
  );

  return (
    <div
      {...props}
      {...getRootProps()}
      className={styles.uploader}
    >
      <input {...getInputProps()} />

      {file ? renderSelectedFileState() : renderDropzoneState()}
    </div>
  );
};
